"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeBaseRequest = void 0;
var ResponseError_1 = require("./ResponseError");
var fetch = require('node-fetch');
var NodeBaseRequest = /** @class */ (function () {
    function NodeBaseRequest(baseUrl) {
        if (baseUrl === void 0) { baseUrl = ''; }
        this.baseUrl = baseUrl;
    }
    NodeBaseRequest.prototype.fetch = function (url, method, body, headers) {
        if (method === void 0) { method = 'GET'; }
        var fullUrl = this.baseUrl + "/" + url;
        return fetch(fullUrl, { method: method, headers: headers, body: body })
            .then(function (r) {
            if (r.status < 200 || r.status >= 300) {
                throw new Error(r.status.toString());
            }
            return r;
        })
            .catch(function (e) {
            //Log.error(e);
            throw new Error(e);
        });
    };
    NodeBaseRequest.prototype.fetchJSON = function (url, method, body, headers) {
        if (method === void 0) { method = 'GET'; }
        return this.fetch(url, method, body, headers)
            .then(function (r) {
            var data = r.json();
            //console.log(fullUrl,data);
            if (data.error) {
                throw new ResponseError_1.ResponseError(data);
            }
            return data;
        })
            .catch(function (e) {
            throw new Error(e);
        });
    };
    return NodeBaseRequest;
}());
exports.NodeBaseRequest = NodeBaseRequest;
